module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-item-container search-item-instagram"
  }, [_c('div', {
    staticClass: "search-item-header"
  }, [_c('div', {
    staticClass: "search-item-title"
  }, [_c('h4', [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.metaData.instagramCaption))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.displayUrl))])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-header-date"
  }, [_vm._v("\n      " + _vm._s(_vm.item.date) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-item-content"
  }, [_c('a', {
    attrs: {
      "href": _vm.item.liveUrl,
      "target": "_blank"
    }
  }, [(
    _vm.item.metaData &&
    _vm.item.metaData.instagramMediaType === 'IMAGE' &&
    _vm.item.metaData.instagramMediaUrl
  ) ? _c('img', {
    attrs: {
      "src": _vm.item.metaData.instagramMediaUrl,
      "alt": 'Thumbnail for ' + _vm.item.title
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.item.metaData &&
    _vm.item.metaData.instagramMediaType === 'VIDEO' &&
    _vm.item.metaData.instagramThumbnailUrl
  ) ? _c('img', {
    attrs: {
      "src": _vm.item.metaData.instagramThumbnailUrl,
      "alt": 'Thumbnail for ' + _vm.item.title
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "search-item-date"
  }, [_vm._v(_vm._s(_vm.item.date) + " ")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.truncatedText)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f5868b6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=csplt5ikear!./~/string-replace-webpack-plugin/loader.js?id=ja005zozwkc!./src/components/search/SearchItemInstagram.vue
// module id = 710
// module chunks = 0